<template>
  <el-tooltip :content="t('admin.noticeCenter.mine')" placement="bottom">
    <el-badge :value="unreadCount || ''" :max="99" :hidden="unreadCount < 1" class="admin-notice-bell">
      <el-button text :icon="Bell" :aria-label="t('admin.noticeCenter.mine')" @click="openMyNotices" />
    </el-badge>
  </el-tooltip>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { Bell } from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

import { ADMIN_NOTICE_READ_EVENT, adminNoticeApi } from '@/api/admin/notice'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const unreadCount = ref(0)

const refresh = async (): Promise<void> => {
  unreadCount.value = await adminNoticeApi.unread().catch(() => 0)
}
const openMyNotices = (): void => {
  void router.push('/admin/notice/notice-user')
}
const refreshFromEvent = (): void => { void refresh() }

watch(() => route.fullPath, () => { void refresh() })
onMounted(() => {
  void refresh()
  window.addEventListener(ADMIN_NOTICE_READ_EVENT, refreshFromEvent)
})
onBeforeUnmount(() => window.removeEventListener(ADMIN_NOTICE_READ_EVENT, refreshFromEvent))
</script>

<style scoped>
.admin-notice-bell :deep(.el-badge__content) { top: 5px; right: 9px; }
</style>
